import Table from "../../../../components/fundamentals/table";
import Spinner from "../../../../components/fundamentals/spinner";
import Button from "../../../../components/fundamentals/button";
import { Supplier, sourceLabel } from "../../../../models/Supplier";

interface IProps {
  supplier: Supplier;
  sources: string[];
  busy: boolean;
  exporting: boolean;
  onChangeSource: (provider: string, source: string) => void;
  onExport: (provider: string) => void;
}

/**
 * RAG-29 — Une ligne fournisseur : code, nombre de produits, sélecteur de PIM
 * source (contrôlé — revient à la valeur courante si le changement est annulé),
 * et date/auteur du dernier changement.
 */
export default function SupplierRow({ supplier, sources, busy, exporting, onChangeSource, onExport }: IProps) {
  return (
    <Table.Row color={"inherit"}>
      <Table.Cell className="font-semibold">{supplier.provider}</Table.Cell>
      <Table.Cell>{supplier.products_count}</Table.Cell>
      <Table.Cell>
        <div className="flex items-center gap-x-2">
          <select
            className="bg-grey-5 border border-gray-20 rounded-rounded h-10 px-small outline-none focus:border-blue-60 disabled:opacity-50"
            value={supplier.source}
            disabled={busy}
            onChange={(e) => onChangeSource(supplier.provider, e.target.value)}
            aria-label={`Source PIM du fournisseur ${supplier.provider}`}
          >
            {sources.map((source) => (
              <option key={source} value={source}>
                {sourceLabel(source)}
              </option>
            ))}
          </select>
          {busy && <Spinner size="small" variant="secondary" />}
        </div>
      </Table.Cell>
      <Table.Cell className="text-grey-50">{supplier.lastChangeLabel()}</Table.Cell>
      <Table.Cell>
        {/* RAG-12 : export CSV des produits du fournisseur + statut de leur visuel. */}
        <Button
          variant="secondary"
          size="small"
          type="button"
          loading={exporting}
          onClick={() => onExport(supplier.provider)}
        >
          Exporter
        </Button>
      </Table.Cell>
    </Table.Row>
  );
}
